module.exports = __webpack_public_path__ + "img/arrow-right-green.9d68db51.svg";